import { Brand } from "@adora/shared/types/brand";
import useBrands from "../../hooks/use-brands";
import BaseBrandDialog from "./base-brand-dialog";
import { BaseDialogProps } from "@adora/shared/contexts/dialog-context";

export interface EditBrandDialogProps extends BaseDialogProps {
  brand: Brand;
}

const EditBrandDialog: React.FC<EditBrandDialogProps> = ({ brand, ...props }) => {
  const { updateBrand } = useBrands();

  return (
    <BaseBrandDialog
      {...props}
      initialValues={{
        name: brand.name,
        description: brand.description ?? "",
        s3Bucket: brand.s3Bucket,
        status: brand.status
      }}
      actionButtonText="Save"
      performAction={(values) => updateBrand(brand.id, values)}
    />
  );
};

export default EditBrandDialog;
